import { AdminSocketRepository } from "../repositories/AdminSocketRepository";

export class AdminDisconnectSocket {
	constructor(private repository: AdminSocketRepository) {}
	execute(): Promise<void> {
		return this.repository.disconnectSocket();
	}
}
